module.exports = __webpack_public_path__ + "static/media/update.96c973f5.svg";